export type RainRuiHistoryItem = {
  startTime: string
  endTime: string
  rainRui: number
  maxMoveRainMin10: number
  maxMoveRainMin10Time: string
  maxMoveRainMin60: number
  maxMoveRainMin60Time: string
}

export type RainRuiHistoryAttributes = {
  stationId: string
  items: RainRuiHistoryItem[]
}

export default class RainRuiHistory {
  public stationId: string
  public data: RainRuiHistoryItem[]

  constructor({ stationId, items }: { stationId: string; items: RainRuiHistoryItem[] }) {
    this.stationId = stationId
    this.data = items
  }
}
